export abstract class Poller<T> {
  private timeoutHandle: number | null = null
  private _data: T | null = null

  get data (): T | null {
    return this._data
  }

  constructor () {
    if (module.hot) {
      module.hot.dispose(() => {
        this.cancel()
      })
    }
  }

  async start () {
    this.cancel()

    let data: T | null
    try {
      data = await this.fetchData()
      this._data = data
      this.didFetchData(data)
    } catch (error) {
      console.error('Failed to fetch data', error)
      data = null
    }
    const timeout = this.pollingTimeout(data)
    if (timeout) {
      setTimeout(() => {
        this.start().then()
      }, timeout)
    }
  }

  cancel () {
    if (this.timeoutHandle) clearTimeout(this.timeoutHandle)
    this.timeoutHandle = null
  }

  abstract fetchData(): Promise<T>
  // eslint-disable-next-line
  didFetchData (data: T) {}
  abstract pollingTimeout(data: T | null): number | null /// In millisecods
}
